import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    Box,
    Grid,
    Stack,
    Typography,
    Paper,
    IconButton,
    Button,
    Backdrop,
    CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast, ToastContainer } from 'react-toastify';

import Resources from './components/Resources';
import BankingScenarioTemplates from './components/BankingScenarioTemplates';
import QuizSection from './components/QuizSection';
import { useDispatch, useSelector } from 'react-redux';
import { activeCorporateConsole, endActiveScenario, startActiveScenario } from '../../../APIConfig/NewCorporateApiConfig';
import CustomModal from '../../../components/ui/CustomModal';
import FeedbackForm from './components/FeedbackForm';
import ProfileCard_ttx from './components/ProfileCard_ttx';

const ViewScenarioExercise = () => {
    const [loader, setLoader] = useState(false)
    const { id } = useParams()
    const [data, setData] = useState()
    const [injects, setInjects] = useState([])

    const navigate = useNavigate();

    const [currentInjectId, setCurrentInjectId] = useState(null);
    const [currentScore, setCurrentScore] = useState(0);
    const [liveInjects, setLiveInjects] = useState([]);
    const [expandedResource, setExpandedResource] = useState(null);

    const wsRef = useRef(null);

    // Derive exercise state from backend flags

    // Merge Redux injects with live injects and sort by order
    // const injects = useMemo(() => {
    //     const reduxInjects = scenarioDataFromRedux?.injects || [];
    //     const allInjects = [...reduxInjects];

    //     // Add live injects that don't already exist in redux injects
    //     liveInjects.forEach((liveInject) => {
    //         const exists = allInjects.some((inj) => inj.id === liveInject.id);
    //         if (!exists) {
    //             allInjects.push(liveInject);
    //         }
    //     });

    //     return allInjects.sort((a, b) => a.order - b.order);
    // }, [scenarioDataFromRedux?.injects, liveInjects]);


    // Derive current inject and index from id
    const currentInjectIndex = useMemo(() => {
        if (!currentInjectId) return 0;
        const index = injects.findIndex((inj) => inj.id === currentInjectId);
        return index >= 0 ? index : 0;
    }, [injects, currentInjectId]);

    const currentInject = injects[currentInjectIndex] || null;

    // Set initial inject id when injects are loaded
    useEffect(() => {
        if (injects.length > 0 && !currentInjectId) {
            setCurrentInjectId(injects[0].id);
        }
    }, [injects, currentInjectId]);





    // WebSocket connection for live injects
    // useEffect(() => {
    //     // const serverUrl = `wss://devapi.bhumiitech.com/ws/injects?user=3&token=${localStorage.getItem('access_token')}`;
    //     const serverUrl = `${process.env.REACT_APP_INJECTS_WEB_SOCKET_URL}injects?user=3&token=${localStorage.getItem('access_token')}`;

    //     const connectWebSocket = () => {
    //         const ws = new WebSocket(serverUrl);

    //         ws.onopen = () => {
    //             console.log('WebSocket connected for live injects');
    //         };

    //         ws.onmessage = (event) => {
    //             try {
    //                 const data = JSON.parse(event.data);

    //                 // Handle new inject pushed by admin
    //                 if (data.type === 'inject_sent' && data.delivery) {
    //                     setLiveInjects((prev) => {
    //                         const exists = prev.some((inj) => inj.id === data.delivery.id);
    //                         if (!exists) {
    //                             toast.info(
    //                                 <Box
    //                                     onClick={() => setCurrentInjectId(data.delivery.id)}
    //                                     sx={{ cursor: 'pointer' }}
    //                                 >
    //                                     New inject received: {data.delivery.title}
    //                                 </Box>,
    //                                 {
    //                                     position: 'top-right',
    //                                     autoClose: 5000,
    //                                 }
    //                             );
    //                             return [...prev, data.delivery];
    //                         }
    //                         return prev;
    //                     });
    //                 }

    //                 // Handle inject update
    //                 if (data.type === 'update_inject' && data.inject) {
    //                     setLiveInjects((prev) =>
    //                         prev.map((inj) =>
    //                             inj.id === data.inject.id ? { ...inj, ...data.inject } : inj
    //                         )
    //                     );
    //                 }

    //                 // Handle inject deletion
    //                 if (data.type === 'delete_inject' && data.inject_id) {
    //                     setLiveInjects((prev) =>
    //                         prev.filter((inj) => inj.id !== data.inject_id)
    //                     );
    //                 }
    //             } catch (err) {
    //                 console.error('Error parsing WebSocket message:', err);
    //             }
    //         };

    //         ws.onclose = (event) => {
    //             console.log('WebSocket disconnected, attempting to reconnect...');
    //             setTimeout(() => {
    //                 if (wsRef.current === ws) {
    //                     connectWebSocket();
    //                 }
    //             }, 3000);
    //         };

    //         ws.onerror = (error) => {
    //             console.error('WebSocket error:', error);
    //         };

    //         wsRef.current = ws;
    //     };

    //     connectWebSocket();

    //     return () => {
    //         if (wsRef.current) {
    //             wsRef.current.close();
    //             wsRef.current = null;
    //         }
    //     };
    // }, [scenarioId]);

    const handleBackClick = () => {
        navigate('/scenarios/active-scenarios');

    };

    const handleNextQuestion = () => {
        if (currentInjectIndex < totalInjects - 1) {
            const nextInject = injects[currentInjectIndex + 1];
            if (nextInject) {
                setCurrentInjectId(nextInject.id);
            }
        }
    };

    const handleScoreUpdate = (updater) => {
        setCurrentScore(updater);
    };



    // api call to get active scenario data 
    const getConsoleData = async () => {
        setLoader(true)
        try {
            const response = await activeCorporateConsole(id);
            if (response?.data) {
                setData(response?.data);
                if (response.data?.participant?.injects) {
                    setInjects(response.data.participant.injects);
                }
                setParticipantStarted(response.data?.participant?.is_started)
                setIs_ended(response.data?.participant?.is_ended)
            }


        } catch (error) {

            toast.error(error?.response?.data?.errors);
            navigate("/scenarios/active-scenarios");

        } finally {
            setLoader(false)
        }
    };

    // api call to get data and injects
    useEffect(() => {
        getConsoleData()
    }, [])

    const totalInjects = injects?.length;
    const status = data?.status;
    const [participantStarted, setParticipantStarted] = useState()
    const [is_ended, setIs_ended] = useState(data?.participant?.is_ended)
    // const [showFeedback, setShowFeedback] = useState(false);
    const [endModal, setEndModal] = useState(false)


    useEffect(() => {
        console.log({ data, is_ended }, 'is_endedis_ended')
    }, [is_ended])



    // start api - active scenario
    const handleStart = async (id) => {
        setLoader(true)
        try {
            const response = await startActiveScenario(id);
            if (response?.data) {
                setData(response?.data);
                if (response.data?.participant?.injects) {
                    setInjects(response.data.participant.injects);
                }
                setParticipantStarted(response.data?.participant?.is_started)
                setIs_ended(response.data?.participant?.is_ended)
            }
        } catch (error) {
            toast.error(error?.response?.data?.errors);
        } finally {
            setLoader(false)
        }

    }

    // end api - active scenario
    const handleEnd = async (id) => {
        try {
            setLoader(true);

            await endActiveScenario(id);

            // re-fetch latest state
            await getConsoleData();

        } catch (error) {
            toast.error(error?.response?.data?.errors);
        } finally {
            setEndModal(false);
        }
    };

    return (
        <>
            {loader ? (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            ) : (
                <>
                    {/* need work it will render when scenario ended (is_ended === true) and feedback given pending */}
                    {
                        <>
                            {/* first check scenario already endedEnded or not */}
                            {data?.participant?.is_ended ? (
                                <>
                                    {/* Completed modal */}
                                    {!data?.participant?.can_submit_feedback && (
                                        <CustomModal
                                            open={true}
                                            hideCloseIcon={true}
                                        >
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Typography
                                                    variant="h2"
                                                    sx={{
                                                        fontWeight: 700,
                                                        mb: 2
                                                    }}
                                                >
                                                    Exercise Completed
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#637381",
                                                        mb: 4.5,
                                                        fontSize: 18,
                                                    }}
                                                >
                                                    This exercise has ended and submissions are now closed.
                                                  
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    onClick={() => navigate("/scenarios/active-scenarios")}
                                                    sx={{
                                                        px: 3,
                                                        borderRadius: "10px",
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    View Active Scenario
                                                </Button>
                                            </Box>
                                        </CustomModal>
                                    )}

                                    {/* Feedback form */}
                                    {data?.participant?.can_submit_feedback &&
                                        !data?.participant?.is_feedback_submitted && (
                                            <FeedbackForm
                                                open={true}
                                                name={data?.participant?.user?.full_name}
                                                scenario={data?.scenario}
                                                participant_id={data?.participant?.id}
                                                team={data?.participant?.team?.name}
                                            />
                                        )}
                                </>

                            ) : (

                                <>
                                    {/* End Button modal */}
                                    <CustomModal
                                        open={endModal}
                                        onClose={() => setEndModal(false)}
                                        sx={{ width: "820px" }}
                                    >
                                        <Box sx={{ p: 3 }}>

                                            {/* Title */}
                                            <Typography
                                                variant="h6"
                                                sx={{ color: "#EAEAEB", mb: 1, fontWeight: 600, fontSize: "24px" }}

                                            >
                                                End Scenario
                                            </Typography>

                                            {/* Message */}
                                            <Typography
                                                sx={{
                                                    color: "#BCBEC1",
                                                    mb: 3,
                                                    lineHeight: 1.7,
                                                    fontSize: "15px"
                                                }}
                                            >
                                                Are you sure you want to end this scenario? <br /><br />
                                                Once you click <strong>End</strong>, the scenario will be permanently closed
                                                and you won’t be able to continue.
                                            </Typography>

                                            {/* Buttons */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    gap: 1
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => setEndModal(false)}
                                                >
                                                    Cancel
                                                </Button>

                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => handleEnd(id)}
                                                >
                                                    End Scenario
                                                </Button>
                                            </Box>

                                        </Box>
                                    </CustomModal>


                                    {/* TTX page */}
                                    <Box sx={{
                                        height: "100%",
                                        bgcolor: "#161C24",
                                        py: 4,
                                        width: "100vw",
                                        px: 4
                                    }}>
                                        {/* Header */}
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                                            <Stack direction="row" alignItems="center" spacing={2} mb={3} >
                                                <IconButton
                                                    onClick={handleBackClick}
                                                    sx={{
                                                        color: '#00B8D9',
                                                        '&:hover': { bgcolor: 'rgba(0, 184, 217, 0.1)' },
                                                    }}
                                                >
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <Box>
                                                    <Typography variant="h3" sx={{ color: '#FFFFFF', fontWeight: 700 }}>
                                                        {data?.scenario?.name}
                                                    </Typography>
                                                </Box>
                                            </Stack>



                                            {/* end Button when participant started is true */}
                                            {participantStarted === true && < Button
                                                variant="outlined"
                                                sx={{
                                                    color: 'white',
                                                    backgroundColor: '#b41e1e',
                                                    borderColor: 'error.main',
                                                    '&:hover': {
                                                        color: 'white',
                                                        borderColor: 'error.dark',
                                                        backgroundColor: '#9b0909',
                                                        opacity: 0.9,


                                                    },
                                                }}
                                                onClick={() => setEndModal(true)}
                                            >
                                                End Scenario
                                            </Button>
                                            }
                                        </Stack>

                                        {/* participant is started false to start the TTX scenario */}
                                        {participantStarted === false && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                    py: 8
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        maxWidth: 640,
                                                        bgcolor: "rgba(0, 184, 217, 0.08)",
                                                        borderRadius: "16px",
                                                        p: 6,
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "40px",
                                                            mb: 3.5,
                                                            display: "inline-block",
                                                            animation: "floatRotate 2s ease-in-out infinite",
                                                            "@keyframes floatRotate": {
                                                                "0%": {
                                                                    transform: "translateY(0px) rotate(0deg)",
                                                                },
                                                                "25%": {
                                                                    transform: "translateY(-4px) rotate(16deg)",
                                                                },
                                                                "50%": {
                                                                    transform: "translateY(-6px) rotate(0deg)",
                                                                },
                                                                "75%": {
                                                                    transform: "translateY(-4px) rotate(-16deg)",
                                                                },
                                                                "100%": {
                                                                    transform: "translateY(0px) rotate(0deg)",
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        ⏳
                                                    </Typography>
                                                    <Typography
                                                        variant="h2"
                                                        sx={{
                                                            color: "#00B8D9",
                                                            fontWeight: 700,
                                                            mb: 2.5
                                                        }}
                                                    >
                                                        Exercise Not Started
                                                    </Typography>

                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "#919EAB",

                                                        }}
                                                    >
                                                        The exercise hasn't started yet. Click the button below to begin and unlock all content.
                                                    </Typography>

                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => navigate('/scenarios/active-scenarios')}
                                                        sx={{
                                                            px: 3,
                                                            borderRadius: "10px",
                                                            textTransform: "none",
                                                            fontWeight: 600,
                                                            mt: 4,
                                                            mr: 1.2
                                                        }}
                                                    >
                                                        Back
                                                    </Button>

                                                    <Button
                                                        variant="contained"
                                                        onClick={() => handleStart(id)}
                                                        sx={{
                                                            px: 3,
                                                            borderRadius: "10px",
                                                            textTransform: "none",
                                                            fontWeight: 600,
                                                            mt: 4,
                                                            ml: 1.2
                                                        }}
                                                    >
                                                        Start Exercise
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )}

                                        {/* participant is started false , so UI is blurred until scenario started - main content*/}
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                ...(participantStarted === false && {
                                                    filter: 'blur(28px)',
                                                    pointerEvents: 'none',
                                                    userSelect: 'none',
                                                }),
                                            }}
                                        >
                                            <Grid container spacing={3}>
                                                {/* Left Column */}
                                                <Grid item xs={12} lg={3}>
                                                    <Stack spacing={2}>

                                                        <Box
                                                            sx={{
                                                                bgcolor: '#1C252E',
                                                                p: 2.5,
                                                                borderRadius: '12px',
                                                                border: '1px solid #454F5B',
                                                                mb: 3,
                                                            }}
                                                        >
                                                            <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: 600, mb: 1.5 }}>
                                                                Injects
                                                            </Typography>
                                                            {injects.map((inject, index) => (
                                                                <Typography
                                                                    key={inject.id}
                                                                    onClick={() => setCurrentInjectId(inject?.id)}
                                                                    variant="h3"
                                                                    sx={{
                                                                        color: '#FFFFFF',
                                                                        lineHeight: 1.8,
                                                                        cursor: 'pointer',
                                                                        '&:hover': { color: '#00B8D9' },
                                                                        bgcolor: currentInjectId === inject.id ? 'rgba(0, 184, 217, 0.2)' : 'transparent',
                                                                        p: 1,
                                                                        borderRadius: '8px',
                                                                        transition: 'all 0.3s ease',
                                                                    }}
                                                                >
                                                                    {index + 1}. {inject.title}
                                                                </Typography>
                                                            ))}
                                                        </Box>
                                                    </Stack>
                                                </Grid>

                                                {/* Middle Column - Quiz */}
                                                <Grid item xs={12} lg={6}>
                                                    <Paper
                                                        sx={{
                                                            bgcolor: '#212B36',
                                                            borderRadius: '16px',
                                                            border: '1px solid rgba(0, 184, 217, 0.15)',
                                                            p: 3,
                                                            minHeight: '600px',
                                                        }}
                                                    >
                                                        <QuizSection
                                                            inject={currentInject}
                                                            injectIndex={currentInjectIndex}
                                                            totalInjects={totalInjects}
                                                            onScoreUpdate={handleScoreUpdate}
                                                            onNextQuestion={handleNextQuestion}
                                                            isSubmitDisabled={is_ended} data={data}
                                                            id={id}
                                                        />
                                                    </Paper>
                                                </Grid>

                                                {/* Right Column - Score Tracker */}
                                                <Grid item xs={12} lg={3}>

                                                    <ProfileCard_ttx
                                                        currentScore={currentScore}
                                                        maxScore={injects.reduce((sum, inj) => sum + (inj.points || 0), 0)}
                                                        currentQuestion={currentInjectIndex + 1}


                                                        name={data?.participant?.user?.full_name}
                                                        team={data?.participant?.team?.name}

                                                        scenario={data?.scenario}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {/* </Container> */}
                                        <ToastContainer />
                                    </Box >
                                </>
                            )}
                        </>}
                </>

            )
            }



        </>
    );
};

export default ViewScenarioExercise;
